// @flow
import * as React from 'react';
import {Handle, Position} from 'react-flow-renderer';

type GeneratorHandleProps = {|
  top?: string,
  translateX?: number,
  id?: string,
|};
export const GeneratorTargetHandle = ({
  top,
  translateX,
  id,
}: GeneratorHandleProps) => (
  <Handle
    type="target"
    position={Position.Left}
    className="diagram-generator"
    id={id || 'generator'}
    style={{
      top: top || 'calc(50% - 8px)',
      width: `16px`,
      height: `16px`,
      background: 'rgb(164,28,78)',
      textAlign: 'center',
      transform: `translateX(${translateX || 0}px)`,
    }}
  />
);

export const GeneratorSourceHandle = ({
  top,
  translateX,
  id,
}: GeneratorHandleProps) => (
  <Handle
    type="source"
    position={Position.Right}
    className="diagram-generator"
    id={id || 'generator'}
    style={{
      top: top || 'calc(50% - 8px)',
      width: `16px`,
      height: `16px`,
      background: 'white',
      border: '1px solid black',
      textAlign: 'center',
      transform: `translateX(${translateX || 0}px)`,
    }}
  />
);

export const TopHandles = () => (
  <>
    <Handle
      type="target"
      position={Position.Top}
      id="top"
      style={{left: '50%', top: '0%'}}
    />
    <Handle
      type="source"
      position={Position.Top}
      id="top"
      style={{left: '50%', top: '0%'}}
    />
  </>
);

export const BottomHandles = () => (
  <>
    <Handle
      type="source"
      position={Position.Bottom}
      id="bottom"
      style={{left: '50%', top: '100%'}}
    />
    <Handle
      type="target"
      position={Position.Bottom}
      id="bottom"
      style={{left: '50%', top: '100%'}}
    />
  </>
);

export const LeftHandles = () => (
  <>
    <Handle
      type="target"
      id="left"
      position={Position.Left}
      style={{top: '50%'}}
    />
    <Handle
      type="source"
      position={Position.Left}
      id="left"
      style={{top: '50%'}}
    />
    <GeneratorTargetHandle />
  </>
);

export const RightHandles = () => (
  <>
    <Handle
      type="target"
      id="right"
      position={Position.Right}
      style={{top: '50%'}}
    />
    <Handle
      type="source"
      position={Position.Right}
      id="right"
      style={{top: '50%'}}
    />
    <GeneratorSourceHandle />
  </>
);
